<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :placeholder="placeholder"
    solo
    flat
    :disabled="disabled"
    :readonly="readonly"
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
  />
</template>

<script>
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
const ALL_TIMES = [
  "09:00 AM", "09:30 AM", "09:45 AM", "10:00 AM", "10:30 AM",
  "11:00 AM", "11:15 AM", "11:30 AM",
  "12:00 PM", "12:30 PM", "12:45 PM",
  "01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM",
  "03:00 PM", "03:15 PM", "03:30 PM",
  "04:00 PM", "04:30 PM", "04:45 PM",
  "05:00 PM", "05:30 PM",
  "06:00 PM", "06:15 PM", "06:30 PM",
  "07:00 PM", "07:30 PM",
  "08:00 PM", "08:30 PM",
  "09:00 PM", "09:30 PM",
  "10:00 PM", "10:30 PM",
  "11:00 PM", "11:30 PM",
];

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD"),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      this.time = null;
      this.emitValue();
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
     
    };
  },
  methods: {
    init() {
      this.time = this.value;
      if (this.type == "start-time" || this.type == "end-time") {
        if (Array.isArray(this.timeList)) {
          const exists = this.timeList.some((item) => item.value === this.time);
          if (!exists) {
            
            this.time = this.type == "start-time" ? "09:00 AM" : "11:30 PM";
            this.emitValue();
          }
        }
      }
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    initTimeList() {
  
      // let startTime = moment().startOf("day");
      // let endTime = moment().endOf("day");
      // let minTime = this.minTime
      //   ? moment(`${this.minDate} ${this.minTime}`)
      //   : null;
      // while (startTime.isBefore(endTime)) {
      //   let value = startTime.add(15, "minutes").format("hh:mm A");
      //   if (startTime && startTime.isSameOrBefore(minTime)) {
      //     this.timeList.push({ text: value, value, disabled: true });
      //   } else {
      //     this.timeList.push({ text: value, value, disabled: false });
      //   }
      // }
    },
  },
  created() {
    this.initTimeList();
  },
  mounted() {
    this.init();
  },

  computed: {

    timeList() {
      if (this.type === "end-time" && this.minTime) {
        return ALL_TIMES
          .filter((t) => moment(t, "hh:mm A").isAfter(moment(this.minTime, "hh:mm A")))
          .map((t) => ({ text: t, value: t, disabled: false }));
      }
      return ALL_TIMES.map((t) => ({ text: t, value: t, disabled: false }));
    },
  },

};
</script>
